import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MouseEvent, useState } from 'react';
import { List, ListItem } from '@mui/material';

import { Text } from '../../shared/uiComponents';
import { PEARL, PRIMARY } from '../../shared/Helpers/colors';
import { useCheckPermission, useScreenWidth } from '../../shared/Helpers/hooks';
import { Bars } from '../../shared/Assets/menuIcons';
import { Close, IlluminateLogo } from '../../shared/Assets/svgIcons';
import { MENU, MenuProperties } from '../../App/constants';
import { DrawerWrapper, MenuItem, MenuItemWrapper } from './styledComponents';
// import LegacyNavigationInfo from "./legacyNavigationInfo";
import { AdminTypes } from '.';

import { useSelector } from '../../redux/store';

const LinkItem = ({
	item,
	open,
	checkAndNavigate,
}: {
	checkAndNavigate?: (navigationFn: () => void) => void;
	item: MenuProperties;
	open: boolean;
}) => {
	const { permissionGranted } = useCheckPermission(item.permission);
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const screenWidth = useScreenWidth();
	const { Icon, title, url } = item;

	const isMobile = screenWidth < 768;
	const isSelected = pathname.includes(url);

	const handleClick = (e: MouseEvent) => {
		if (checkAndNavigate) {
			e.preventDefault();
			checkAndNavigate(() => navigate(url));
		}
	};

	if (!permissionGranted) return null;

	return (
		<MenuItemWrapper isSelected={isSelected}>
			<Link to={url} onClick={handleClick}>
				<ListItem disablePadding>
					<MenuItem>
						{Boolean(Icon) && (
							<div style={{ width: '20px', textAlign: 'center' }}>
								<Icon color={isMobile && !isSelected ? PEARL.BASE[500] : undefined} />
							</div>
						)}
						{open && (
							<Text title={title} fontWeight="medium" color={pathname.includes(url) ? PRIMARY.BASE : PEARL.BASE[900]} />
						)}
					</MenuItem>
				</ListItem>
			</Link>
		</MenuItemWrapper>
	);
};

const MenuElements = ({
	menu,
	open,
	checkAndNavigate,
}: {
	checkAndNavigate?: (navigationFn: () => void) => void;
	menu: MenuProperties[];
	open: boolean;
}) => (
	<List>
		{menu.map((item, index) => (
			<LinkItem key={index} item={item} open={open} checkAndNavigate={checkAndNavigate} />
		))}
	</List>
);

const MobileAdminMenu = ({ checkAndNavigate }: { checkAndNavigate?: (navigationFn: () => void) => void }) => {
	const navigate = useNavigate();

	const [open, setOpen] = useState<boolean>(false);

	const closeMenuHandler = () => setOpen(false);

	const navigateToDashboardHandler = () => {
		const navFn = () => {
			closeMenuHandler();
			navigate('/dashboard');
		};

		if (checkAndNavigate) {
			checkAndNavigate(navFn);
		} else {
			navFn();
		}
	};

	return (
		<>
			<div style={{ width: '20px', textAlign: 'center' }} onClick={() => setOpen(true)}>
				<Bars color={PEARL.BASE[500]} />
			</div>
			<DrawerWrapper
				variant="temporary"
				anchor="bottom"
				open={open}
				PaperProps={{ style: { borderRadius: '16px 16px 0 0', width: '100%' } }}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						height: '72px',
						padding: '4px 16px 4px 32px',
					}}
				>
					<div onClick={navigateToDashboardHandler} style={{ cursor: 'pointer' }}>
						<IlluminateLogo />
					</div>
					<div style={{ width: '20px', textAlign: 'center' }} onClick={closeMenuHandler}>
						<Close />
					</div>
				</div>
				<div style={{ padding: '16px' }} onClick={closeMenuHandler}>
					<MenuElements menu={MENU.ADMIN_URLS} open checkAndNavigate={checkAndNavigate} />
				</div>
				{/* <LegacyNavigationInfo /> */}
			</DrawerWrapper>
		</>
	);
};

export const MobileMenu = ({ checkAndNavigate }: { checkAndNavigate?: (navigationFn: () => void) => void }) => {
	const role = useSelector((state) => state.account.role);

	const isAdmin = role?.section.id === AdminTypes.admin;
	const isBCBA = role?.section.id === AdminTypes.bcba;
	const isBT = role?.section.id === AdminTypes.bt;
	const isCS = role?.section.id === AdminTypes.cs;

	return (
		<div className="mobileMenu">
			{(isAdmin || isBT) &&
				MENU.GENERAL.map((item, index) => (
					<LinkItem key={index} item={item} open={false} checkAndNavigate={checkAndNavigate} />
				))}
			{(isBCBA || isCS) &&
				MENU.BCBA.map((item, index) => (
					<LinkItem key={index} item={item} open={false} checkAndNavigate={checkAndNavigate} />
				))}
			{isAdmin && <MobileAdminMenu checkAndNavigate={checkAndNavigate} />}
		</div>
	);
};

export default MenuElements;
